// src/pages/LandingPage.tsx
//
// Home / welcome content. Module navigation lives in the global app sidebar, so
// this is a clean welcome screen (no tile grid). A configurable per-tenant /
// per-user "default tab as home" is a planned follow-up — until then this is the
// neutral landing that avoids showing modules a tenant may not have.

import { Home } from 'lucide-react';
import { useAuthContext } from '../hooks/useAuth';
import type { Page } from '../App';

// Kept for a stable props shape (App passes onNavigate); nav now lives in the sidebar.
interface LandingPageProps {
  onNavigate: (page: Page) => void;
}

export default function LandingPage(_props: LandingPageProps) {
  const { user, branding } = useAuthContext();

  return (
    <div className="min-h-full bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center">
      <div className="text-center px-6 max-w-lg">
        <div className="w-14 h-14 rounded-2xl bg-blue-500/15 text-blue-300 flex items-center justify-center mx-auto mb-5">
          <Home size={26} />
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">
          Welcome back{user?.firstName ? `, ${user.firstName}` : ''}
        </h2>
        <p className="text-slate-400">
          {branding?.company_name ? `You're viewing ${branding.company_name}. ` : ''}
          Pick a module from the sidebar on the left to get started.
        </p>
      </div>
    </div>
  );
}
